import {SurveyComponentTypes} from '../components/surveys/types';

export const INITIAL_QUERY = {
  direction: 'desc',
  page: '1',
  per_page: '10',
  simple_search: '',
  sort: '',
  completed: 'ANY',
  date_created: 'ANY'
};

export const COMPLETED_FILTER_OPTIONS = [
  {value: 'ANY', label: 'Any'},
  {value: 'YES', label: 'Yes'},
  {value: 'NO', label: 'No'}
];

export const DATE_CREATED_FILTER_OPTIONS = [
  {value: 'ANY', label: 'Any'},
  {value: 'TODAY', label: 'Today'},
  {value: 'YESTERDAY', label: 'Yesterday'},
  {value: 'THIS_WEEK', label: 'This Week'},
  {value: 'LAST_WEEK', label: 'Last Week'},
  {value: 'THIS_MONTH', label: 'This Month'},
  {value: 'LAST_MONTH', label: 'Last Month'}
];

export const EDITABLE_COMPONENTS = {
  RATING: SurveyComponentTypes.RATING,
  TEXT: SurveyComponentTypes.TEXT,
  TEXTAREA: SurveyComponentTypes.TEXTAREA,
  RADIO: SurveyComponentTypes.RADIO
};
